import type { CSSProperties } from 'react';
import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { spacing } = theme;

export interface SearchSuggestionsCSSProperties extends CSSProperties {
  '--suggestionsHeight': string;
}

export const searchSuggestionsContainer = css`
  position: absolute;
  left: 0;
  right: 0;
  margin-top: ${spacing.base}px;
  height: var(--suggestionsHeight);
  background-color: var(--neutral-white-base);
  z-index: 4;
`;
